import { render, staticRenderFns } from "./VCardList.vue?vue&type=template&id=e52d53bc"
import script from "./VCardList.vue?vue&type=script&lang=js"
export * from "./VCardList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports